import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';
	import { MAINTENANCE_ENABLED } from '@/constants';
	import { NavigationItem } from '@cnamts/vue-dot/src/patterns/HeaderBar/types';
	import AmeliBanner from './ameli-banner.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'app-header',
  setup(__props) {

	const radiologistRedirectUrl = window.URL_RADIOLOGIST;
	const insuredRedirectUrl = window.URL_INSURED;

	function navigationItems(): NavigationItem[] | null {
		if (MAINTENANCE_ENABLED) {
			return null;
		}

		return [
			{
				label: 'Annuaire',
				to: {
					name: 'search'
				}
			}
		];
	}

	/**
	 * Détermine si l'application est en vue mobile
	 */
	function isMobile(): boolean | undefined {
		return getCurrentInstance()?.proxy.$vuetify.breakpoint.smAndDown;
	}

return { __sfc: true,radiologistRedirectUrl, insuredRedirectUrl, navigationItems, isMobile, AmeliBanner }
}

})